import { ProviderAuthenticationCommon } from '~/plugins/data-connector/authentication/common'
import { Oauth2ServerConnectionType } from '~/plugins/data-connector/authentication/strategies/oauth2/oauth2.server'

export const ProviderXeroCommon = {
  key: 'xero',
  authentication: ProviderAuthenticationCommon.Oauth2({
    key: 'xero',
    authUrl: 'https://login.xero.com/identity/connect/authorize',
    tokenUrl: 'https://identity.xero.com/connect/token',
    scopes: [
      'offline_access',
      'accounting.transactions',
      'openid',
      'profile',
      'email',
      'accounting.contacts',
      'accounting.settings',
    ],
  }),
}

export type XeroTenant = {
  id: string
  name: string
}

export type ProviderXeroAccountType = {
  tenants: XeroTenant[]
}

export type ProviderXeroConnectionType = Oauth2ServerConnectionType & {
  id_token: string
}
